module.exports = __webpack_public_path__ + "assets/img/burst_kinesis.5b23e51f.png";